import React, { useMemo, useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import Select from 'react-select';
import { isAdmin } from 'utils/userTypeHelper';
import useUser from 'utils/useUser';
import forms from 'constants/forms';
import common from 'constants/common';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from 'components/molecules/pagination';
import AutoCompleteAgencyDoctor from 'components/molecules/autocompleteFilter/agencyDoctor';
import AutoCompleteAgency from 'components/molecules/autocompleteFilter/agency';
import RoleTypes from '../../../../../../constants/roleTypes';

const Toolbar = () => {
  const { userType } = useUser();
  const DEFAULT_AGENCY_DOCTOR_FILTER = forms.agencyDoctorFilterOptions[0];
  const DEFAULT_AGENCY_FILTER = forms.agencyDoctorFilterOptions[1];
  const statusFilterOptions = forms.loginStatusFilterSelect;

  const selectTheme = (theme) => ({
    ...theme,
    borderRadius: 12,
    colors: {
      ...theme.colors,
      ...common.primaryColors,
    },
  });
  const {
    page,
    data,
    itemsPerPage,
    totalCount,
    filters: { roleName, status },
  } = useSelector((state) => state.adminPanelAgencyDoctors);

  const rolesOptions = useMemo(() =>
    RoleTypes.map(({ value, label }) => ({
      value,
      label,
    })),
  );
  const roleValue = useMemo(
    () => RoleTypes.find(({ value }) => roleName === value) || RoleTypes[0],
  );
  const statusValue = useMemo(() =>
    statusFilterOptions.find(({ value }) => status === value),
  );

  const {
    adminPanelAgencyDoctors: { setFilters, updateAgencyDoctorPage, reset },
  } = useDispatch();
  const setPage = (pageOffset) => {
    updateAgencyDoctorPage({ pageOffset });
  };
  const agencyFilter = DEFAULT_AGENCY_FILTER;
  const agencyDoctorFilter = DEFAULT_AGENCY_DOCTOR_FILTER;

  useEffect(() => {
    reset();
  }, []);

  return (
    <Row>
      <Col sm={3} md={2}>
        <strong>Full Name</strong>
        <AutoCompleteAgencyDoctor
          filter={agencyDoctorFilter}
          roleName={roleName}
          status={status}
          handleClick={({ value }) => {
            setFilters({ guid: value });
          }}
        />
      </Col>
      <Col sm={3} md={2}>
        <strong>Role</strong>
        <Select
          options={rolesOptions}
          defaultValue={roleName}
          theme={(theme) => selectTheme(theme)}
          classNamePrefix="select-type"
          value={roleValue}
          onChange={({ value }) => setFilters({ roleName: value })}
        />
      </Col>
      {isAdmin(userType) && (
        <Col sm={3} md={2}>
          <strong>Agency</strong>
          <AutoCompleteAgency
            filter={agencyFilter}
            handleClick={({ value }) => {
              setFilters({ agencyGuid: value });
            }}
          />
        </Col>
      )}

      <Col sm={3} md={2}>
        <strong>Status</strong>
        <Select
          options={statusFilterOptions}
          defaultValue={statusFilterOptions[0]}
          theme={(theme) => selectTheme(theme)}
          classNamePrefix="select-type"
          value={statusValue}
          onChange={({ value }) => {
            setFilters({ status: value });
          }}
        />
      </Col>

      <Col column="4" />
      <Col sm={3} md={2}>
        <Pagination
          title=""
          page={page}
          pageTotal={data.length}
          itemsPerPage={itemsPerPage}
          total={totalCount}
          handleFirstClick={() => setPage(-(page - 1))}
          handleLastClick={() => setPage(Math.ceil(totalCount / itemsPerPage))}
          handlePrevClick={() => setPage(-1)}
          handleNextClick={() => setPage(+1)}
          loading={false}
        />
      </Col>
    </Row>
  );
};

export default Toolbar;
